import { formatShortDate } from "cy-util";
import { TableColumn, TableRow } from "./models";

export const tableUtils = {
  getDisplayValue(col: TableColumn, row: TableRow) {
    const cell = this.getCell(col, row);
    if (col.render) {
      return col.render(col, row, cell || {});
    }
    return cell;
  },
  getCell(col: TableColumn, row: TableRow) {
    return row.columns[col.key];
  },

  /**
   * Converts an array of object with key value pairs to table row structure
   * @param rows
   */
  convertObjectToTableData(
    rows?: Record<string, any>[]
  ): TableRow[] | undefined {
    if (!rows) return undefined;
    return rows.map((r) => {
      const keys = Object.keys(r);
      const row: TableRow = { columns: {}, data: r, href: r.href };
      for (const key of keys) {
        const value = r[key];

        row.columns[key] =
          value instanceof Date ? formatShortDate(value) : value;
      }
      row.href = r.href;
      return row;
    });
  },
};
